var map = {
	"./manafuda_sato.png": 4821,
	"./manafuda_suzuki.png": 607,
	"./manafuda_tanaka.png": 783,
	"./old/sato_l.png": 9725,
	"./old/suzuki_l.png": 8165,
	"./old/tanaka_l.png": 4998,
	"./sato.png": 7028,
	"./sato_1.png": 6568,
	"./sato_2.png": 342,
	"./sato_3.png": 2979,
	"./sato_4.png": 9140,
	"./sato_5.png": 2985,
	"./suzuki.png": 5860,
	"./suzuki_1.png": 7875,
	"./suzuki_2.png": 6821,
	"./suzuki_3.png": 7573,
	"./tanaka.png": 7025,
	"./tanaka_1.png": 2601,
	"./tanaka_2.png": 2526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4533;